<script setup>
import { ref } from 'vue'
import FormButton from '../Atoms/FormButton.vue'
import IconBase from '../icon/IconBase.vue'
import IconCopy from '../icon/IconCopy.vue'
import IconCheckmark from '../icon/IconCheckmark.vue'
import { clipboardCopy } from '@/utils'

const props = defineProps({
  text: {
    type: String,
  },
  withText: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  label: {
    type: String,
    default: 'Copy to Clipboard',
  },
  size: {
    type: String,
    default: 'sm',
  },
  fixedWidth: {
    type: String,
    default: 'w-40',
  },
  customClasses: {
    type: String,
    default: '',
  },
  isIcon: {
    type: Boolean,
    default: false,
  },
  outline: {
    type: Boolean,
    default: false,
  },
})

// Refs
const isCopying = ref(false)
const copyTimeout = ref(null)

// Methods
const copyToClipboard = async (text) => {
  isCopying.value = true
  copyTimeout.value = setTimeout(() => {
    isCopying.value = false
  }, 1000)
  await clipboardCopy(text)
}
</script>

<template>
  <VDropdown popperClass="copy-popover" placement="top" :shown="isCopying">
    <template #popper>
      <span>Copied</span>
    </template>
    <FormButton :customClasses="props.customClasses" @click="copyToClipboard(props.text)" :isIcon="!withText || isIcon" :type="withText || outline ? 'secondary' : 'link'"
      :size="size" :disabled="disabled">
      <template v-if="withText">
        <div class="flex items-center gap-x-2 justify-center" :class="fixedWidth" v-if="!isCopying">
          <IconBase fill="none" class="shrink-0">
            <IconCopy />
          </IconBase>
          {{ label }}
        </div>
        <div class="flex items-center gap-x-2 justify-center" :class="fixedWidth" v-else>
          <IconBase fill="none" class="shrink-0">
            <IconCheckmark class="text-success" />
          </IconBase>
          Copied
        </div>
      </template>
      <template v-else>
        <IconBase fill="none">
          <IconCopy v-if="!isCopying" />
          <IconCheckmark class="text-success" v-else />
        </IconBase>
      </template>
    </FormButton>
  </VDropdown>
</template>

<style>
.copy-popover .v-popper__inner {
 @apply bg-surface-2 border-surface-1 rounded-2xl shadow-dropdown !px-4 !py-1 text-tiny text-surface-9;
}
.copy-popover  .v-popper__arrow-inner {
  @apply border-surface-2;
}
.copy-popover  .v-popper__arrow-outer {
  @apply border-surface-1;
}
</style>